/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, ContractFactory, Interface, } from "ethers";
const _abi = [
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "allowanceKey",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint128",
                        name: "balance",
                        type: "uint128",
                    },
                    {
                        internalType: "uint128",
                        name: "consumed",
                        type: "uint128",
                    },
                ],
                internalType: "struct Consumption[]",
                name: "c1",
                type: "tuple[]",
            },
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "allowanceKey",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint128",
                        name: "balance",
                        type: "uint128",
                    },
                    {
                        internalType: "uint128",
                        name: "consumed",
                        type: "uint128",
                    },
                ],
                internalType: "struct Consumption[]",
                name: "c2",
                type: "tuple[]",
            },
        ],
        name: "merge",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "allowanceKey",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint128",
                        name: "balance",
                        type: "uint128",
                    },
                    {
                        internalType: "uint128",
                        name: "consumed",
                        type: "uint128",
                    },
                ],
                internalType: "struct Consumption[]",
                name: "result",
                type: "tuple[]",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
];
const _bytecode = "0x608060405234801561000f575f80fd5b506106998061001d5f395ff3fe608060405234801561000f575f80fd5b5060043610610029575f3560e01c8063d8d025c21461002d575b5f80fd5b61004061003b36600461052b565b610056565b60405161004d919061058b565b60405180910390f35b6060610062838361006b565b90505b92915050565b606082515f0361007c575080610065565b81515f0361008b575081610065565b815183516100999190610604565b67ffffffffffffffff8111156100b1576100b16103ea565b6040519080825280602002602001820160405280156100fa57816020015b604080516060810182525f80825260208083018290529282015282525f199092019101816100cf5790505b5083519091505f5b818110156101f05784818151811061011c5761011c610617565b60200260200101515f015183828151811061013957610139610617565b60200260200101515f01818152505084818151811061015a5761015a610617565b60200260200101516020015183828151811061017857610178610617565b6020026020010151602001906001600160801b031690816001600160801b0316815250508481815181106101ae576101ae610617565b6020026020010151604001518382815181106101cc576101cc610617565b60209081029190910101516001600160801b03909116604090910152600101610102565b505f5b835181101561037d575f806102248787858151811061021457610214610617565b60200260200101515f0151610392565b9150915080156102875785838151811061024057610240610617565b60200260200101516040015185838151811061025e5761025e610617565b6020026020010151604001818151610276919061062b565b6001600160801b0316905250610373565b85838151811061029957610299610617565b60200260200101515f01518585815181106102b6576102b6610617565b60200260200101515f0181815250508583815181106102d7576102d7610617565b6020026020010151602001518585815181106102f5576102f5610617565b6020026020010151602001906001600160801b031690816001600160801b03168152505085838151811061032b5761032b610617565b60200260200101516040015185858151811061034957610349610617565b60209081029190910101516001600160801b039091166040909101528361036f8161064b565b9450505b50506001016101f3565b50815181101561038b578082525b5092915050565b81515f908190815b818110156103da57848682815181106103b5576103b5610617565b60200260200101515f0151036103d2579250600191506103e39050565b60010161039a565b505f8092509250505b9250929050565b634e487b7160e01b5f52604160045260245ffd5b6040516060810167ffffffffffffffff81118282101715610421576104216103ea565b60405290565b604051601f8201601f1916810167ffffffffffffffff81118282101715610450576104506103ea565b604052919050565b80356001600160801b038116811461046e575f80fd5b919050565b5f82601f830112610482575f80fd5b8135602067ffffffffffffffff82111561049e5761049e6103ea565b6104ac818360051b01610427565b828152606092830285018201928282019190878511156104ca575f80fd5b8387015b8581101561051e5781818a0312156104e5575f8081fd5b6104ed6103fe565b813581526104fc868301610458565b86820152604061050d818401610458565b9082015284529284019281016104ce565b5090979650505050505050565b5f806040838503121561053c575f80fd5b823567ffffffffffffffff80821115610553575f80fd5b61055f86838701610473565b93506020850135915080821115610574575f80fd5b5061058185828601610473565b9150509250929050565b602080825282518282018190525f919060409081850190868401855b828110156105e357815180518552868101516001600160801b0390811688870152908601511685850152606090930192908501906001016105a7565b5091979650505050505050565b634e487b7160e01b5f52601160045260245ffd5b80820180821115610065576100656105f0565b634e487b7160e01b5f52603260045260245ffd5b6001600160801b0381811683821601908082111561038b5761038b6105f0565b5f6001820161065c5761065c6105f0565b506001019056fea26469706673582212205822c6a352cc1739d1f1dbaaa398bec302b55a245e7c546787537529ece5af6464736f6c63430008150033";
const isSuperArgs = (xs) => xs.length > 1;
export class MockConsumptions__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
